<template>
  <div class="app__klarna__wrapper js__product__klarna">
    <slot />
  </div>
</template>
